import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./user/userSlice";
import orderReducer from "./orders/orderSlice";
import clientReducer from "./client/clientSlice";

export const store = configureStore({
  reducer: {
    user: userReducer,
    order: orderReducer,
    client: clientReducer,
  },
});

